import * as i0 from '@angular/core';
import { Component, Injectable, Input, NgModule } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import * as i1 from 'abs-ngx-library/src/lib/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from 'abs-ngx-library/src/lib/quantity-stepper';
import { QuantityStepperModule } from 'abs-ngx-library/src/lib/quantity-stepper';
import * as i4 from 'abs-ngx-library/src/lib/auto-replenishment-al-v1';
import { AutoReplenishmentALV1Module } from 'abs-ngx-library/src/lib/auto-replenishment-al-v1';
import * as i5 from 'abs-ngx-library/src/lib/product-coupon';
import { ProductCouponModule } from 'abs-ngx-library/src/lib/product-coupon';

const _c0 = a0 => ({ "pc-contained": a0 });
const _c1 = a0 => ({ "product-comp-v1__price__saleprice sunshine50 rounded": a0 });
const _c2 = a0 => ({ "pc__tooltip ": a0 });
function ProductItemALV2Component_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵlistener("click", function ProductItemALV2Component_a_1_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.sendAdIdClickEvent(); ctx_r1.onProductClicked(); return i0.ɵɵresetView(ctx_r1.setPfmDetailProduct()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattributeInterpolate3("aria-label", "", (ctx_r1.product == null ? null : ctx_r1.product.fullName == null ? null : ctx_r1.product.fullName.length) ? ctx_r1.product.fullName : ctx_r1.product.name, ",price approximatly ", i0.ɵɵpipeBind2(1, 5, ctx_r1.validPrice, "USD"), " ", ctx_r1.isLBProduct() ? "lb" : "each", "");
    i0.ɵɵattribute("href", ctx_r1.productDetailPath, i0.ɵɵsanitizeUrl);
} }
function ProductItemALV2Component_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-qa", ctx_r1.isProductSubscribed ? "ar-schdld-subscrbd" : "bia_bdg");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.isProductSubscribed ? "Subscribed" : "Buy again");
} }
function ProductItemALV2Component_ng_container_4_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "img", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.product.name);
    i0.ɵɵproperty("src", ctx_r1.getImageUrl(ctx_r1.product.id, "desktop"), i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("data-src", ctx_r1.getImageUrl(ctx_r1.product.id, "desktop"));
} }
function ProductItemALV2Component_ng_container_4_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 28);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.product.name);
    i0.ɵɵattribute("data-src", ctx_r1.getImageUrl(ctx_r1.product.id, "desktop"));
} }
function ProductItemALV2Component_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23)(2, "div", 24)(3, "picture");
    i0.ɵɵelement(4, "source", 25)(5, "source", 25);
    i0.ɵɵtemplate(6, ProductItemALV2Component_ng_container_4_ng_container_6_Template, 2, 3, "ng-container", 26)(7, ProductItemALV2Component_ng_container_4_ng_template_7_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const noSrc_r3 = i0.ɵɵreference(8);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", "pg" + ctx_r1.product.id + "Img");
    i0.ɵɵattribute("data-bpn", ctx_r1.product.id);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.bgImgOpaque);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("media", "(max-width: ", ctx_r1.sm, ")");
    i0.ɵɵattribute("data-srcset", ctx_r1.getImageUrl(ctx_r1.product.id, "mobile"));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("media", "(max-width: ", ctx_r1.md, ")");
    i0.ɵɵattribute("data-srcset", ctx_r1.getImageUrl(ctx_r1.product.id, "tablet"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.configObj == null ? null : ctx_r1.configObj.appName) === "dnf" || (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) === "dnf")("ngIfElse", noSrc_r3);
} }
function ProductItemALV2Component_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "quantity-stepper-al-v2", 29);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "pg", ctx_r1.product.id, "-qty");
    i0.ɵɵproperty("product", ctx_r1.product)("configObj", ctx_r1.configObj);
} }
function ProductItemALV2Component_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 30);
    i0.ɵɵtext(2, " approx. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function ProductItemALV2Component_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 31);
    i0.ɵɵtext(2, "Sponsored");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function ProductItemALV2Component_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "lowercase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" / ", ctx_r1.isLBProduct() ? i0.ɵɵpipeBind1(2, 1, ctx_r1.product.unitQuantity) : ctx_r1.product.displayUnitQuantityText, "");
} }
function ProductItemALV2Component_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "lowercase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" / ", ctx_r1.product.averageWeightStr, " ", ctx_r1.isLBProduct() ? i0.ɵɵpipeBind1(2, 2, ctx_r1.product.unitQuantity) : ctx_r1.product.displayUnitQuantityText, "");
} }
function ProductItemALV2Component_del_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "del", 33)(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 34);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Original Price ", i0.ɵɵpipeBind2(3, 2, ctx_r1.product.basePrice, "USD"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 5, ctx_r1.product.basePrice, "USD"), "");
} }
function ProductItemALV2Component_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 35)(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 34);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "currency");
    i0.ɵɵpipe(8, "titlecase");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "pg" + ctx_r1.product.id + "unitPer");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("price per ", i0.ɵɵpipeBind1(3, 5, ctx_r1.product.unitQuantity), " ", i0.ɵɵpipeBind2(4, 7, ctx_r1.product.showStrikeThrough ? ctx_r1.product.pricePer : ctx_r1.product.basePricePer, "USD"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("(", i0.ɵɵpipeBind2(7, 10, ctx_r1.product.showStrikeThrough ? ctx_r1.product.pricePer : ctx_r1.product.basePricePer, "USD"), " / ", i0.ɵɵpipeBind1(8, 13, ctx_r1.product.unitQuantity), ")");
} }
function ProductItemALV2Component_ng_container_26_auto_replenishment_al_v1_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "auto-replenishment-al-v1", 37);
    i0.ɵɵlistener("setDetailProduct", function ProductItemALV2Component_ng_container_26_auto_replenishment_al_v1_1_Template_auto_replenishment_al_v1_setDetailProduct_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setPfmDetailProduct()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("product", ctx_r1.product)("productDetailPath", ctx_r1.productDetailPath)("calledBy", "product-grid-item")("isPcRedesignDisabled", false);
} }
function ProductItemALV2Component_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductItemALV2Component_ng_container_26_auto_replenishment_al_v1_1_Template, 1, 4, "auto-replenishment-al-v1", 36);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showArSubscription());
} }
function ProductItemALV2Component_a_28_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 38);
    i0.ɵɵlistener("click", function ProductItemALV2Component_a_28_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.sendAdIdClickEvent(); ctx_r1.onProductClicked(); return i0.ɵɵresetView(ctx_r1.setPfmDetailProduct()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "pg" + ctx_r1.product.id);
    i0.ɵɵattribute("data-bpn", ctx_r1.product.id)("href", ctx_r1.productDetailPath, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.product.name, " ");
} }
function ProductItemALV2Component_span_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "pg" + ctx_r1.product.id);
    i0.ɵɵattribute("data-bpn", ctx_r1.product.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.product.name, " ");
} }
function ProductItemALV2Component_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelement(1, "div", 41);
    i0.ɵɵelementStart(2, "div", 42);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.product.fullName);
} }
function ProductItemALV2Component_ng_container_31_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tag_r6.srOnlyText);
} }
function ProductItemALV2Component_ng_container_31_span_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 48);
    i0.ɵɵtext(1, " | ");
    i0.ɵɵelementEnd();
} }
function ProductItemALV2Component_ng_container_31_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, ProductItemALV2Component_ng_container_31_span_2_span_1_Template, 2, 1, "span", 45);
    i0.ɵɵelementStart(2, "span", 46);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProductItemALV2Component_ng_container_31_span_2_span_4_Template, 2, 0, "span", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tag_r6.srOnlyText);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-qa", tag_r6.qaAttribute)("aria-hidden", tag_r6.srOnlyText ? "true" : "false");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tag_r6.displayableText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pcTags.length > i_r7 + 1);
} }
function ProductItemALV2Component_ng_container_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵtemplate(2, ProductItemALV2Component_ng_container_31_span_2_Template, 5, 5, "span", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.pcTags);
} }
function ProductItemALV2Component_ng_container_32_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 53);
} if (rf & 2) {
    const review_r8 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", "svg-star-icon-" + review_r8 + "-filled");
} }
function ProductItemALV2Component_ng_container_32_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 50);
    i0.ɵɵtemplate(1, ProductItemALV2Component_ng_container_32_div_1_span_1_Template, 1, 1, "span", 51);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 52);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.ratingStars);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("Rated ", ctx_r1.product == null ? null : ctx_r1.product.productReview == null ? null : ctx_r1.product.productReview.avgRating, " out of 5, ", ctx_r1.product == null ? null : ctx_r1.product.productReview == null ? null : ctx_r1.product.productReview.reviewCount, " reviews");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.product == null ? null : ctx_r1.product.productReview == null ? null : ctx_r1.product.productReview.reviewCount);
} }
function ProductItemALV2Component_ng_container_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductItemALV2Component_ng_container_32_div_1_Template, 6, 4, "div", 49);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showPCReview(ctx_r1.product));
} }
function ProductItemALV2Component_ng_container_33_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "product-coupon-al-v2", 54);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("product", ctx_r1.product)("productOffers", ctx_r1.productOffers)("configObj", ctx_r1.configObj);
} }
function ProductItemALV2Component_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductItemALV2Component_ng_container_33_ng_container_1_Template, 2, 3, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.productCouponVisible);
} }
function ProductItemALV2Component_ng_container_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 55)(2, "span");
    i0.ɵɵtext(3, "Sold & shipped by");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 56)(5, "a", 57);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵattribute("href", ctx_r1.sellerLandingPath, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.product.sellerName);
} }
function ProductItemALV2Component_ng_container_35_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 61);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, ctx_r1.reservedTimeIntent), " unavailable (Requires ", ctx_r1.product == null ? null : ctx_r1.product.mtoDisplyableTime, ")");
} }
function ProductItemALV2Component_ng_container_35_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 62);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.product["itemNotAvailableTxt"]);
} }
function ProductItemALV2Component_ng_container_35_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 63);
    i0.ɵɵlistener("click", function ProductItemALV2Component_ng_container_35_ng_container_4_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.viewSimilarClick()); });
    i0.ɵɵtext(2, "Similar products");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-label", "Similar products ", ctx_r1.product.name, "");
} }
function ProductItemALV2Component_ng_container_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 58);
    i0.ɵɵtemplate(2, ProductItemALV2Component_ng_container_35_span_2_Template, 3, 4, "span", 59)(3, ProductItemALV2Component_ng_container_35_span_3_Template, 2, 1, "span", 60)(4, ProductItemALV2Component_ng_container_35_ng_container_4_Template, 3, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.displayableElements == null ? null : ctx_r1.displayableElements.mto) && ctx_r1.itemAvailable && !ctx_r1.isMtoItemEligibleToAdd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.itemAvailable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
} }
class ProductItemALV2Component {
    constructor(commonService, productUtilService, aemService, elementRef, _userInfoService, intersectionObserverService, _elementRef) {
        this.commonService = commonService;
        this.productUtilService = productUtilService;
        this.aemService = aemService;
        this.elementRef = elementRef;
        this._userInfoService = _userInfoService;
        this.intersectionObserverService = intersectionObserverService;
        this._elementRef = _elementRef;
        this.imagePath = '//images.albertsons-media.com/is/image/ABS/${product.id}?$grid-product-card-${viewport}$&defaultImage=Not_Available';
        this.reservedTimeIntent = '';
        this.isCalledByRightDrawerOrSns = false;
        this.productDetailPath = '';
        this.sm = '575px';
        this.md = '768px';
        this.bgImgOpaque = 'product-image-opaque-full';
        this.itemAvailable = true;
        this.isArEnable = false;
        this.isMtoItemEligibleToAdd = true;
        this.subscription = new Subscription();
        this.sellerLandingPath = '';
        this.productOffers = {};
        this.isProductSubscribed = false;
        this.pcTags = [];
        this.isOneTimeSnsCouponsDisabled = true;
        this.isCustomizableProduct = false;
        this.hideBuyAgainTag = false;
        /**
        * Method to check Schedule and Save
        */
        this.showArSubscription = () => this.isArEnable && !!this.product && this.product.isArProduct && this.commonService.isActiveProduct(this.product);
        this.getStarRatings = (rating) => {
            if (rating) {
                const averageRating = Number(rating);
                const fullStarsCount = Math.floor(averageRating);
                const partialStarIndex = fullStarsCount > 0 ? fullStarsCount : 0;
                const partialStar = (averageRating - fullStarsCount) * 100;
                const arrFinalStarPercentages = [];
                let finalPartialStarPercentage = 0;
                switch (true) {
                    case (partialStar > 0 && partialStar <= 25):
                        finalPartialStarPercentage = 0;
                        break;
                    case (partialStar > 25 && partialStar <= 75):
                        finalPartialStarPercentage = 50;
                        break;
                    case (partialStar > 75 && partialStar <= 100):
                        finalPartialStarPercentage = 100;
                        break;
                    default:
                        break;
                }
                for (let i = 0; i < 5; i++) {
                    if (i < fullStarsCount) {
                        arrFinalStarPercentages[i] = 100;
                    }
                    else if (i == partialStarIndex) {
                        arrFinalStarPercentages[i] = finalPartialStarPercentage;
                    }
                    else {
                        arrFinalStarPercentages[i] = 0;
                    }
                }
                return arrFinalStarPercentages;
            }
            return [0, 0, 0, 0, 0];
        };
    }
    set product(product) {
        this.addElipsis(product);
        this.commonService.checkStrikeThrough(product);
        this._product = product;
        this.ratingStars = this.getStarRatings(product?.productReview?.avgRating);
    }
    get product() {
        return this._product;
    }
    ngOnInit() {
        this.isOneTimeSnsCouponsDisabled = this.aemService.getFeatureFlagByNameDisable('isOneTimeSnsCouponsDisabled');
        this.performInitialChecks();
        this.setDisplayableElements();
        this.getLatestArSubData();
        this.setSellerLandingPath();
        this.setTagDisplayableElements();
        this.enableOOSReDesign = this.calledBy == 'buy-it-again';
        this.hideBuyAgainTag = this.calledBy === 'buy-it-again' || this.calledBy === 'buy-it-again-qsc';
        if (!this.enableOOSReDesign) {
            this.itemAvailable = this.commonService.isItemAvailable_v2(this.product, this.configObj?.programType);
        }
        else {
            this.itemAvailable = this.commonService.isItemAvailable_v3(this.product, this.configObj?.programType);
        }
    }
    performInitialChecks() {
        // Check for arFlag else listen to arFlagLoaded
        if (window['AB']['arFlagLoaded']) {
            this.isArEnable = window['AB']['arFlag']['display'];
            this.isCustomizableProduct = this.commonService.isProductEligibleForCustomization(window['AB'].storeFlagsData, this.product);
        }
        else {
            this.subscription.add(fromEvent(document, 'arFlagLoaded').subscribe(event => {
                this.isArEnable = event && event['detail'] && event['detail']['arFlag'] ? event['detail']['arFlag']['display'] : false;
                // set isCustomizableProduct flag based on store eligibility and isMtoProduct/isCustomizable
                this.isCustomizableProduct = this.commonService.isProductEligibleForCustomization(window['AB'].storeFlagsData, this.product);
            }));
        }
        //Set productOffers for snsOneTime
        this.productOffers = this.commonService.getOffersByUpc(this.product, this.offers);
        //Checking Item is available based on status & some other 
        this.itemAvailable = this.commonService.isItemAvailable_v3(this.product, this.configObj?.programType, true);
        this.configObj = this.product.isMarketplaceItem == 'Y' ? { ...this.configObj, programType: 'mkp' } : this.configObj;
        this.productDetailPath = this.commonService.getProductDetailPath(this.configObj?.programType);
        if (this.productDetailPath) {
            this.productDetailPath = this.productDetailPath.replace('(bpn)', this._product.id);
        }
        this.validPrice = this.commonService.getValidProductPrice(this._product);
        //Checking if the product is MTO and we are in edit order flow
        if (this.commonService.checkPendingOrder() && this.product?.isMtoProduct) {
            const abSlotEditOrder = localStorage.getItem('abSlotEditOrder');
            this.reservedTimeIntent = JSON.parse(abSlotEditOrder)?.serviceType ?? '';
            if (abSlotEditOrder) {
                this.isMtoItemEligibleToAdd = !this.commonService.preparationTimeExceedsPrebook(this.product, 'abSlotEditOrder');
            }
            else {
                this.isMtoItemEligibleToAdd = false;
            }
        }
        if (this.product['averageWeight'] < 1 && this.product['averageWeight'] > 0 && this.product.displayUnitQuantityText !== 'ea') {
            this.product['averageWeightStr'] = this.product['averageWeight'][0].substring(1, 4);
        }
        //added coupons check
        this.productCouponVisible = this.itemAvailable && this.calledBy !== 'c-products-by-upc-drawer' && this.calledBy !== 's-bogo';
    }
    getLatestArSubData() {
        // subscribing to the behavioral subject - arSubscriptions
        this.subscriptionSNS = this.commonService.arSubscriptions.subscribe((data) => {
            if (!!data && !this.commonService.isEmpty(data)) {
                this.isProductSubscribed = data.subscribedItems[this.product.id] && data.subscribedItems[this.product.id]?.isActiveSubscription;
            }
        });
    }
    setTagDisplayableElements() {
        this.pcTags = this.productUtilService.productTagElements(this.product, this.displayableElements);
    }
    // To get elements as per IDisplayableElements interface
    setDisplayableElements() {
        const programType = this.configObj?.programType ? this.configObj?.programType : 'abs';
        this.displayableElements = this.productUtilService.getProductDisplayableElementsByProgramType(programType);
    }
    //Adding ellipses to product name if it is greater than 60 characters
    addElipsis(product) {
        if (product?.name && product?.name.trim().length > 60) {
            product['fullName'] = product['name'];
            product['name'] = product?.name.slice(0, 30) + '...' + product?.name.slice(-20);
        }
    }
    setSellerLandingPath() {
        if (this.configObj?.programType && (this.configObj.programType === 'mkp' || this.configObj.programType === 'mkp-carousel' || (this.product?.isMarketplaceItem && this.product.isMarketplaceItem === 'Y'))) {
            this.sellerLandingPath = this.commonService.getSellerLandingPath(this.product.sellerId);
        }
    }
    ngAfterViewInit() {
        if (this.product &&
            this.product['adId'] || this.product.eventTracking) {
            this.intersectionObserverService.createObserver(this._elementRef.nativeElement, this.product);
        }
        // Trigger lazy loading for all pagination types.
        if (window['AB']['LAZYLOAD'] && typeof window['AB']['LAZYLOAD'].init == 'function') {
            window['AB']['LAZYLOAD'].init();
        }
    }
    getImageUrl(id, viewport) {
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
    }
    //For citrusAdTracker refering to V1 on Click of image 
    sendAdIdClickEvent() {
        this.commonService.sendSponsoredProductClickEvent(this.product, 'productCardGridOrCrossSell', 'viewProductDetails');
    }
    /**
     * Method to handle clicking on product refering to V1 calling on Image and Product Name
    **/
    onProductClicked() {
        // make ad relevance call for all products
        this.commonService.recordRelevanceImpression(this.product, 'productCardGridOrCrossSell', 'viewProductDetails');
    }
    //Checking isLBProduct() while diaplay price
    isLBProduct() {
        return this.product?.displayType === '3' && (this.product?.sellByWeight === 'W' || this.product?.sellByWeight === 'P');
    }
    // Sets the pfmDetail in localStorage to be used in analytics tracking on pdp navigation
    setPfmDetailProduct(isSpotlight) {
        if (window['AB']?.DATALAYER) {
            const analyticsProductInfo = {
                isSpotlight: isSpotlight,
                isPastPurchased: this._product?.pastPurchased,
                isSponsored: this._product?.featured,
                pathwaysWidget: this.pathwaysWidget
            };
            window['AB'].DATALAYER.setPfmDetailProductItemToPDP(this.elementRef.nativeElement, this._product, analyticsProductInfo);
        }
    }
    showPCReview(product) {
        return (this.calledBy !== 'buy-it-again'
            && product
            && product.productReview
            && product.productReview.isReviewDisplayEligible === 'true'
            && product.productReview.avgRating
            && product.productReview.avgRating != ''
            && product.productReview.avgRating != '0.0'
            && product.productReview.avgRating != '0'
            && product.productReview.avgRating != null
            && product.productReview.reviewCount > 0);
    }
    viewSimilarClick() {
        if (this.calledBy && this.calledBy == 'buy-it-again') {
            this.commonService.showBiaLPCrossSell(this.product.id);
            if (window['AB'] && window['AB'].DATALAYER) {
                window['AB'].DATALAYER.setViewSimilarItemsClick(this._product);
            }
        }
        else {
            let redirectUrl = "/bin/safeway/product/similar?aisleId={product.aisleId}";
            redirectUrl = redirectUrl.replace('{product.aisleId}', this.product.aisleId);
            window.location.href = redirectUrl;
        }
    }
    analyticsSimilarItemsCTA() {
        if (window['AB']?.DATALAYER) {
            window['AB'].DATALAYER.analyticsCTATracking(`cta:${window['AB'].DATALAYER.pathSections?.join(':')}|link|view-similar-items`);
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.subscriptionSNS.unsubscribe();
    }
    static { this.ɵfac = function ProductItemALV2Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductItemALV2Component)(i0.ɵɵdirectiveInject(i1.CommonService), i0.ɵɵdirectiveInject(i1.ProductUtilService), i0.ɵɵdirectiveInject(i1.AemService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UserInfoService), i0.ɵɵdirectiveInject(i1.IntersectionObserverService), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProductItemALV2Component, selectors: [["product-item-al-v2"]], inputs: { pathwaysWidget: "pathwaysWidget", configObj: "configObj", isCalledByRightDrawerOrSns: "isCalledByRightDrawerOrSns", offers: "offers", isAnyProductHasAddlInfo: "isAnyProductHasAddlInfo", unAttendDeliveryFlag: [0, "isRestricted", "unAttendDeliveryFlag"], calledBy: "calledBy", product: [0, "data", "product"] }, decls: 36, vars: 38, consts: [["noSrc", ""], [1, "pc", "p-3", "position-relative", 3, "ngClass"], ["class", "w-100 h-100 position-absolute pc__tap-zone", 3, "click", 4, "ngIf"], [4, "ngIf"], [1, "pc__tc"], [1, "d-flex", "align-items-end", "justify-content-end", "position-relative", "w-100", "pc__tc__cta-container"], [1, "pc__bc"], [1, "d-flex", "flex-column", "align-items-start", "align-self-stretch", "pt-1", "pc__bc__gap"], [1, "d-flex", "flex-column", "align-self-stretch"], [1, "d-flex", "body-text-xs", "pc__text-xxs", "color-neutral-80", "pc__label-container"], [1, "product-comp-v1__price", "d-flex", "align-items-baseline", "flex-wrap"], ["data-qa", "prd-itm-prc", 1, "product-comp-v1__price__text", 3, "id", "ngClass"], [1, "sr-only"], ["aria-hidden", "true", 1, "color-neutral-90"], ["aria-hidden", "true", "data-qa", "qty-txt", 4, "ngIf"], ["class", "body-text-xxs color-neutral-80", "data-qa", "prd-itm-prc-del", 4, "ngIf"], ["class", "body-text-xxs color-neutral-80", "data-qa", "prd-itm-pprc-qty", "aria-hidden", "true", 3, "id", 4, "ngIf"], [1, "position-relative", 3, "ngClass"], ["class", "title-xxs color-neutral-90", "data-qa", "prd-itm-pttl", "tabindex", "-1", 3, "id", "click", 4, "ngIf"], ["class", "title-xxs color-neutral-90", "data-qa", "prd-itm-pttl", 3, "id", 4, "ngIf"], ["class", "pc__tooltip__title", 4, "ngIf"], [1, "w-100", "h-100", "position-absolute", "pc__tap-zone", 3, "click"], [1, "background-color-neutral-20", "color-neutral-90", "pc__text-xxs", "body-text-xs", "text-center", "rounded", "px-1", "position-absolute", "pc__badge"], [1, "pc__tc__imgc", "p-1", "d-flex", "justify-content-center"], [3, "id"], [3, "media"], [4, "ngIf", "ngIfElse"], ["data-qa", "prd-itm-img", 1, "ab-lazy", "pc__tc__imgc__img", "w-100", "h-100", 3, "src", "alt"], ["data-qa", "prd-itm-img", 1, "ab-lazy", "pc__tc__imgc__img", "w-100", "h-100", 3, "alt"], [1, "w-100", "d-flex", "justify-content-end", 3, "id", "product", "configObj"], ["aria-hidden", "false", "data-qa", "pr-itm-aprx"], ["aria-hidden", "false", "data-qa", "prd-itm-spnsrd", 1, "ml-auto"], ["aria-hidden", "true", "data-qa", "qty-txt"], ["data-qa", "prd-itm-prc-del", 1, "body-text-xxs", "color-neutral-80"], ["aria-hidden", "true"], ["data-qa", "prd-itm-pprc-qty", "aria-hidden", "true", 1, "body-text-xxs", "color-neutral-80", 3, "id"], [3, "product", "productDetailPath", "calledBy", "isPcRedesignDisabled", "setDetailProduct", 4, "ngIf"], [3, "setDetailProduct", "product", "productDetailPath", "calledBy", "isPcRedesignDisabled"], ["data-qa", "prd-itm-pttl", "tabindex", "-1", 1, "title-xxs", "color-neutral-90", 3, "click", "id"], ["data-qa", "prd-itm-pttl", 1, "title-xxs", "color-neutral-90", 3, "id"], [1, "pc__tooltip__title"], [1, "pc__tooltip__title__arrow-light"], [1, "title-xxs", "color-neutral-90"], [1, "w-100"], [4, "ngFor", "ngForOf"], ["class", "sr-only", 4, "ngIf"], [1, "pc__tags"], ["class", "pc__tags-divider", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "pc__tags-divider"], ["class", "rating-stars d-flex align-items-center", 4, "ngIf"], [1, "rating-stars", "d-flex", "align-items-center"], ["class", "mr-0", "aria-hidden", "true", 3, "ngClass", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "body-text-xxs", "color-neutral-80"], ["aria-hidden", "true", 1, "mr-0", 3, "ngClass"], [1, "position-relative", 3, "product", "productOffers", "configObj"], [1, "title-xxxs", "pt-2"], [1, "links", "m-0"], [1, "links__action", "link-xs", "position-relative"], [1, "pt-2"], ["class", "title-xxxs color-neutral-80", 4, "ngIf"], ["aria-hidden", "false", "class", "title-xxxs color-neutral-80", "data-qa", "prd-itm-oos", 4, "ngIf"], [1, "title-xxxs", "color-neutral-80"], ["aria-hidden", "false", "data-qa", "prd-itm-oos", 1, "title-xxxs", "color-neutral-80"], ["data-qa", "prd-itm-vw-smlr-itms", 1, "links__action", "link-xs", "position-relative", 3, "click"]], template: function ProductItemALV2Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, ProductItemALV2Component_a_1_Template, 2, 8, "a", 2)(2, ProductItemALV2Component_ng_container_2_Template, 3, 2, "ng-container", 3);
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵtemplate(4, ProductItemALV2Component_ng_container_4_Template, 9, 13, "ng-container", 3);
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtemplate(6, ProductItemALV2Component_ng_container_6_Template, 2, 4, "ng-container", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "div", 8)(10, "div", 9);
            i0.ɵɵtemplate(11, ProductItemALV2Component_ng_container_11_Template, 3, 0, "ng-container", 3)(12, ProductItemALV2Component_ng_container_12_Template, 3, 0, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(13);
            i0.ɵɵelementStart(14, "div", 10)(15, "span", 11)(16, "span", 12);
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "currency");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "span", 13);
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "currency");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, ProductItemALV2Component_span_22_Template, 3, 3, "span", 14)(23, ProductItemALV2Component_span_23_Template, 3, 4, "span", 14);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, ProductItemALV2Component_del_24_Template, 7, 8, "del", 15)(25, ProductItemALV2Component_span_25_Template, 9, 15, "span", 16);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(26, ProductItemALV2Component_ng_container_26_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementStart(27, "div", 17);
            i0.ɵɵtemplate(28, ProductItemALV2Component_a_28_Template, 2, 4, "a", 18)(29, ProductItemALV2Component_span_29_Template, 2, 3, "span", 19)(30, ProductItemALV2Component_div_30_Template, 4, 1, "div", 20);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(31, ProductItemALV2Component_ng_container_31_Template, 3, 1, "ng-container", 3)(32, ProductItemALV2Component_ng_container_32_Template, 2, 1, "ng-container", 3)(33, ProductItemALV2Component_ng_container_33_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(34, ProductItemALV2Component_ng_container_34_Template, 7, 2, "ng-container", 3)(35, ProductItemALV2Component_ng_container_35_Template, 5, 3, "ng-container", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(32, _c0, ctx.isCalledByRightDrawerOrSns));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.configObj == null ? null : ctx.configObj.programType) !== "1P_SNS");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.hideBuyAgainTag && (ctx.isProductSubscribed || (ctx.displayableElements == null ? null : ctx.displayableElements.buyItAgain) && (ctx.product == null ? null : ctx.product.pastPurchased)));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.displayableElements == null ? null : ctx.displayableElements.image);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.displayableElements == null ? null : ctx.displayableElements.addToCart) && ctx.itemAvailable && ctx.isMtoItemEligibleToAdd);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", (ctx.product == null ? null : ctx.product.displayEstimateText) === "approx");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.displayableElements == null ? null : ctx.displayableElements.sponsoredLabel) && (ctx.product == null ? null : ctx.product.featured));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("id", "pg" + ctx.product.id + "price");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c1, ctx.product.showStrikeThrough));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2("Your Price ", i0.ɵɵpipeBind2(18, 26, ctx.validPrice, "USD"), " ", ctx.isLBProduct() ? "lb" : "each", "");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(21, 29, ctx.validPrice, "USD"), "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.product.displayUnitQuantityText || ctx.isLBProduct()) && ctx.product.averageWeight == 1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.product.displayUnitQuantityText || ctx.isLBProduct()) && ctx.product.averageWeight < 1 && ctx.product.averageWeight > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.product.showStrikeThrough);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isLBProduct());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isCustomizableProduct && (ctx.displayableElements == null ? null : ctx.displayableElements.scheduleNSave) && (!ctx.unAttendDeliveryFlag || ctx.product.restrictedValue == 0));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c2, (ctx.product == null ? null : ctx.product.fullName == null ? null : ctx.product.fullName.length) > 60));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.configObj == null ? null : ctx.configObj.programType) !== "1P_SNS");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.configObj == null ? null : ctx.configObj.programType) === "1P_SNS");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.product == null ? null : ctx.product.fullName == null ? null : ctx.product.fullName.length) > 60);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pcTags.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.displayableElements == null ? null : ctx.displayableElements.starRating);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.displayableElements == null ? null : ctx.displayableElements.coupons) && ctx.itemAvailable && (ctx.configObj.programType !== "1P_SNS" || !ctx.isOneTimeSnsCouponsDisabled));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.displayableElements == null ? null : ctx.displayableElements.sellerTag) && ctx.product.isMarketplaceItem == "Y" && ctx.product.sellerId && ctx.product.sellerName);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.itemAvailable || ctx.itemAvailable && !ctx.isMtoItemEligibleToAdd);
        } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.QuantityStepperALV2Component, i4.AutoReplenishmentALV1Component, i5.ProductCouponALV2Component, i2.LowerCasePipe, i2.TitleCasePipe, i2.CurrencyPipe], encapsulation: 2 }); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductItemALV2Component, factory: ProductItemALV2Component.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductItemALV2Component, [{
        type: Component,
        args: [{ selector: 'product-item-al-v2', template: "<div [ngClass] = \"{'pc-contained' : isCalledByRightDrawerOrSns}\" class=\"pc p-3 position-relative\">\n<a *ngIf=\"configObj?.programType !== '1P_SNS'\" class=\"w-100 h-100 position-absolute pc__tap-zone\" (click)=\" sendAdIdClickEvent(); onProductClicked(); setPfmDetailProduct()\" [attr.href]=\"productDetailPath\" \nattr.aria-label=\"{{ (product?.fullName?.length) ? product.fullName : product.name }},price approximatly {{ validPrice | currency: 'USD' }} {{isLBProduct() ? 'lb' : 'each'}}\"></a>\n\n    <ng-container *ngIf=\"!hideBuyAgainTag && (isProductSubscribed || (displayableElements?.buyItAgain && product?.pastPurchased))\" >\n        <span [attr.data-qa]=\"isProductSubscribed ? 'ar-schdld-subscrbd' : 'bia_bdg'\" class=\"background-color-neutral-20 color-neutral-90 pc__text-xxs body-text-xs text-center rounded px-1 position-absolute pc__badge\">{{isProductSubscribed ? 'Subscribed' : 'Buy again'}}</span>\n    </ng-container>\n    \n    <div class=\"pc__tc\">\n        <ng-container  *ngIf=\"displayableElements?.image\">\n            <div class=\"pc__tc__imgc p-1 d-flex justify-content-center\">\n                <div id=\"{{'pg' + product.id + 'Img'}}\" attr.data-bpn=\"{{ product.id }}\">\n                    <picture class=\"{{bgImgOpaque}}\">\n                        <source media=\"(max-width: {{sm}})\" [attr.data-srcset]=\"getImageUrl(product.id,'mobile')\">\n                        <source media=\"(max-width: {{md}})\" [attr.data-srcset]=\"getImageUrl(product.id,'tablet')\">\n                        <ng-container *ngIf=\"configObj?.appName === 'dnf' || configObj?.programType === 'dnf'; else noSrc\">\n                            <img class=\"ab-lazy pc__tc__imgc__img w-100 h-100\" [attr.data-src]=\"getImageUrl(product.id,'desktop')\"\n                                [src]=\"getImageUrl(product.id,'desktop')\" alt=\"{{ product.name }}\" data-qa=\"prd-itm-img\" />\n                        </ng-container>\n                        <ng-template #noSrc>\n                            <img class=\"ab-lazy pc__tc__imgc__img w-100 h-100\" [attr.data-src]=\"getImageUrl(product.id,'desktop')\"\n                                alt=\"{{ product.name }}\" data-qa=\"prd-itm-img\" />\n                        </ng-template>\n                    </picture>\n                </div>\n            </div>\n        </ng-container>\n\n        <div class=\"d-flex align-items-end justify-content-end position-relative w-100 pc__tc__cta-container\">\n            <!-- Quantity Stepper-->\n            <ng-container *ngIf=\"displayableElements?.addToCart && itemAvailable && isMtoItemEligibleToAdd\">\n                <quantity-stepper-al-v2 id=\"pg{{product.id}}-qty\"\n                    [product]=\"product\" \n                    [configObj]=\"configObj\" class=\"w-100 d-flex justify-content-end\">\n                </quantity-stepper-al-v2>\n            </ng-container>\n        </div>\n    </div>\n\n    <div class=\"pc__bc\">\n        <div class=\"d-flex flex-column align-items-start align-self-stretch pt-1 pc__bc__gap\">\n            <div class=\"d-flex flex-column align-self-stretch\">\n                <div class=\"d-flex body-text-xs pc__text-xxs color-neutral-80 pc__label-container\">\n                    <ng-container *ngIf=\"product?.displayEstimateText === 'approx' \">\n                        <span aria-hidden=\"false\" data-qa=\"pr-itm-aprx\">\n                            approx.\n                        </span>\n                    </ng-container>\n                    <ng-container *ngIf=\"displayableElements?.sponsoredLabel && product?.featured\">\n                        <span class=\"ml-auto\" aria-hidden=\"false\" data-qa=\"prd-itm-spnsrd\">Sponsored</span>\n                    </ng-container>\n\n                </div>\n\n                <ng-container>\n                    <!-- Product Price -->\n                    <div class=\"product-comp-v1__price d-flex align-items-baseline flex-wrap\">\n                        <span id=\"{{'pg' + product.id + 'price'}}\" data-qa=\"prd-itm-prc\" class=\"product-comp-v1__price__text \" [ngClass]=\"{'product-comp-v1__price__saleprice sunshine50 rounded' : product.showStrikeThrough }\">\n                            <span class=\"sr-only\">Your Price {{ validPrice | currency: 'USD' }}  {{isLBProduct() ? 'lb' : 'each'}}</span>\n                            <span class=\"color-neutral-90\" aria-hidden=\"true\"> {{ validPrice | currency: 'USD' }}</span>\n                            \n                            <span *ngIf=\"(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight == 1\" aria-hidden=\"true\" data-qa=\"qty-txt\"> /\n                                {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>\n                            <span *ngIf=\"(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight < 1 && product.averageWeight > 0\" aria-hidden=\"true\" data-qa=\"qty-txt\"> /\n                                {{ product.averageWeightStr }}\n                                {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>\n\n                        </span>\n                        <del class=\"body-text-xxs color-neutral-80\" *ngIf=\"product.showStrikeThrough\" data-qa=\"prd-itm-prc-del\">\n                            <span class=\"sr-only\">Original Price  {{product.basePrice | currency: 'USD' }}</span>\n                            <span aria-hidden=\"true\"> {{product.basePrice | currency: 'USD' }}</span>\n                        </del>\n                        <!-- Displaying product.basePrice and product.basePrice based on showStrikeThrough-->\n                        <span class=\"body-text-xxs color-neutral-80\" id=\"{{'pg' + product.id + 'unitPer'}}\" data-qa=\"prd-itm-pprc-qty\" *ngIf=\"!isLBProduct()\" aria-hidden=\"true\">\n                            <span class=\"sr-only\" >price per {{ product.unitQuantity | titlecase}} {{ (product.showStrikeThrough ? product.pricePer : product.basePricePer) | currency: 'USD' }}</span>\n                            <span aria-hidden=\"true\">({{ (product.showStrikeThrough ? product.pricePer : product.basePricePer) | currency: 'USD' }} / {{ product.unitQuantity | titlecase}})</span>\n                        </span>\n                    </div>\n                </ng-container>\n            </div>\n\n            <!-- Schedule and Save  -->\n            <ng-container *ngIf=\"(!isCustomizableProduct) && displayableElements?.scheduleNSave &&  (!unAttendDeliveryFlag || product.restrictedValue == 0)\">\n                <auto-replenishment-al-v1 *ngIf=\"showArSubscription()\" \n                    [product]=\"product\"\n                    [productDetailPath]=\"productDetailPath\" \n                    (setDetailProduct)=\"setPfmDetailProduct()\"\n                    [calledBy]=\"'product-grid-item'\"\n                    [isPcRedesignDisabled]=\"false\">\n                </auto-replenishment-al-v1>\n            </ng-container>   \n            \n            <!-- Product Title -->\n            <div [ngClass]=\"{'pc__tooltip ' : product?.fullName?.length > 60}\" class=\"position-relative\">\n\n                <a *ngIf=\"configObj?.programType !== '1P_SNS'\" id=\"{{'pg' + product.id}}\" attr.data-bpn=\"{{ product.id }}\" class=\"title-xxs color-neutral-90\" data-qa=\"prd-itm-pttl\" (click)=\" sendAdIdClickEvent(); onProductClicked(); setPfmDetailProduct()\" [attr.href]=\"productDetailPath\" tabindex=\"-1\">\n                    {{ product.name }} \n                </a>\n                <span *ngIf=\"configObj?.programType === '1P_SNS'\" id=\"{{'pg' + product.id}}\" attr.data-bpn=\"{{ product.id }}\" class=\"title-xxs color-neutral-90\" data-qa=\"prd-itm-pttl\">\n                    {{ product.name }}\n                </span>\n                <div *ngIf=\"product?.fullName?.length > 60\" class=\"pc__tooltip__title\">\n                    <div class=\"pc__tooltip__title__arrow-light\"></div>\n                    <div class=\"title-xxs color-neutral-90\">{{product.fullName}}</div>\n                </div>\n            </div> \n            <!-- Snap & mto text-->\n\n            <ng-container *ngIf=\"pcTags.length > 0\">\n                <div class=\"w-100\">\n                    <span *ngFor=\"let tag of pcTags; let i = index\">\n                        <span *ngIf=\"tag.srOnlyText\" class=\"sr-only\">{{ tag.srOnlyText }}</span>\n                        <span class=\"pc__tags\" [attr.data-qa]=\"tag.qaAttribute\"\n                            [attr.aria-hidden]=\"tag.srOnlyText ? 'true' : 'false'\">\n                            {{ tag.displayableText }}\n                        </span>\n                        <span class=\"pc__tags-divider\" *ngIf=\"pcTags.length > i + 1\" aria-hidden=\"true\">\n                            |\n                        </span>\n                    </span>\n                </div>\n            </ng-container>\n\n            <!-- Product Rating -->\n            <ng-container *ngIf=\"displayableElements?.starRating\">\n                <div class=\"rating-stars d-flex align-items-center\" *ngIf=\"showPCReview(product)\">\n                    <span *ngFor=\"let review of ratingStars; let i = index\" [ngClass]=\"'svg-star-icon-' + review + '-filled'\" class=\"mr-0\" aria-hidden=\"true\"></span>\n                    <span class=\"sr-only\">Rated {{product?.productReview?.avgRating}} out of 5, {{product?.productReview?.reviewCount}} reviews</span>\n                    <span aria-hidden=\"true\" class=\"body-text-xxs color-neutral-80\">{{product?.productReview?.reviewCount}}</span>\n                </div>\n            </ng-container>\n        \n            <!-- Product Coupon \"-->\n            <ng-container *ngIf=\"displayableElements?.coupons && itemAvailable && (configObj.programType !== '1P_SNS' || !isOneTimeSnsCouponsDisabled)\">\n                <ng-container *ngIf=\"productCouponVisible\">\n                    <product-coupon-al-v2\n                        [product]=\"product\"\n                        [productOffers]=\"productOffers\"\n                        [configObj]=\"configObj\" \n                        class=\"position-relative\">\n                    </product-coupon-al-v2>\n                </ng-container>\n            </ng-container>\n        </div>    \n        <!-- Displaying days as static upto now-->\n\n        <ng-container *ngIf=\"displayableElements?.sellerTag && product.isMarketplaceItem == 'Y' && product.sellerId && product.sellerName\">\n            <div class=\"title-xxxs pt-2\">\n                <span>Sold & shipped by</span>\n                <div class=\"links m-0\">\n                    <a class=\"links__action link-xs position-relative\"\n                    [attr.href]=\"sellerLandingPath\">{{product.sellerName}}</a>\n                </div>\n            </div>\n        </ng-container>     \n        <ng-container *ngIf=\"!itemAvailable || (itemAvailable && !isMtoItemEligibleToAdd) \">\n            <div class=\"pt-2\">\n                <span class=\"title-xxxs color-neutral-80\" *ngIf=\"displayableElements?.mto && itemAvailable && !isMtoItemEligibleToAdd\">{{(reservedTimeIntent | titlecase)}} unavailable (Requires {{product?.mtoDisplyableTime}})</span>\n                <span aria-hidden=\"false\" *ngIf=\"!itemAvailable\" class=\"title-xxxs color-neutral-80\" data-qa = \"prd-itm-oos\">{{product['itemNotAvailableTxt']}}</span>\n                <ng-container *ngIf=\"configObj?.programType !== '1P_SNS'\">\n                    <a class=\"links__action link-xs position-relative\" data-qa = \"prd-itm-vw-smlr-itms\"  attr.aria-label=\"Similar products {{product.name}}\" (click)=\"viewSimilarClick()\">Similar products</a>\n                </ng-container>\n            </div>\n        </ng-container>   \n    </div>\n</div>\n\n" }]
    }, {
        type: Injectable
    }], () => [{ type: i1.CommonService }, { type: i1.ProductUtilService }, { type: i1.AemService }, { type: i0.ElementRef }, { type: i1.UserInfoService }, { type: i1.IntersectionObserverService }, { type: i0.ElementRef }], { pathwaysWidget: [{
            type: Input,
            args: ['pathwaysWidget']
        }], configObj: [{
            type: Input
        }], isCalledByRightDrawerOrSns: [{
            type: Input
        }], offers: [{
            type: Input,
            args: ['offers']
        }], isAnyProductHasAddlInfo: [{
            type: Input
        }], unAttendDeliveryFlag: [{
            type: Input,
            args: ['isRestricted']
        }], calledBy: [{
            type: Input,
            args: ['calledBy']
        }], product: [{
            type: Input,
            args: ['data']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProductItemALV2Component, { className: "ProductItemALV2Component", filePath: "product-item-al-v2/product-item-al-v2.component.ts", lineNumber: 16 }); })();

class ProductItemALV2Module {
    static { this.ɵfac = function ProductItemALV2Module_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductItemALV2Module)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ProductItemALV2Module }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            ProductItemALV2Component
        ], imports: [CommonModule,
            QuantityStepperModule,
            AutoReplenishmentALV1Module,
            ProductCouponModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductItemALV2Module, [{
        type: NgModule,
        args: [{
                declarations: [ProductItemALV2Component],
                exports: [
                    ProductItemALV2Component,
                ],
                imports: [
                    CommonModule,
                    QuantityStepperModule,
                    AutoReplenishmentALV1Module,
                    ProductCouponModule
                ],
                providers: [
                    ProductItemALV2Component
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ProductItemALV2Module, { declarations: [ProductItemALV2Component], imports: [CommonModule,
        QuantityStepperModule,
        AutoReplenishmentALV1Module,
        ProductCouponModule], exports: [ProductItemALV2Component] }); })();

// //Component

/**
 * Generated bundle index. Do not edit.
 */

export { ProductItemALV2Component, ProductItemALV2Module };
